class MediaStackVideo extends HTMLElement {
  connectedCallback () {
    this.video = this.querySelector('video')
    this.video.muted = true
    this.mobileQuery = window.matchMedia('(max-width: 749px)')
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    this.inView = false

    this.handleChange = () => this.setSource()
    this.mobileQuery.addEventListener('change', this.handleChange)
    this.setSource()

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.inView = entry.isIntersecting
        this.inView ? this.play() : this.video.pause()
      },
      { rootMargin: '200px 0px' }
    )
    this.observer.observe(this)
  }

  disconnectedCallback () {
    this.mobileQuery.removeEventListener('change', this.handleChange)
    this.observer.disconnect()
  }

  setSource () {
    const isMobile = this.mobileQuery.matches
    const src = isMobile ? this.dataset.srcMobile : this.dataset.srcDesktop

    if (!src) {
      if (this.video.hasAttribute('src')) {
        this.video.pause()
        this.video.removeAttribute('src')
        this.video.load()
      }
      return
    }

    if (this.video.getAttribute('src') === src) return

    this.video.poster = isMobile ? this.dataset.posterMobile : this.dataset.posterDesktop
    this.video.src = src
    if (this.inView) this.play()
  }

  play () {
    if (this.reducedMotion) return
    this.video.play().catch(() => {})
  }
}

if (!customElements.get('media-stack-video')) {
  customElements.define('media-stack-video', MediaStackVideo)
}
